<h3 *ngIf="customerForm.controls.id.value">Edit Customer</h3>
<h3 *ngIf="!customerForm.controls.id.value">Add Customer</h3>

<div class="customer-edit-container">
    <form [formGroup]="customerForm" (ngSubmit)="onSubmit()">

        <input formControlName="id" type="hidden">

        <mat-form-field class="customer-form-field">
            <mat-label>Name</mat-label>
            <input matInput placeholder="Name" formControlName="name" required>
            <mat-error *ngIf="customerForm.controls?.name?.hasError('required')">
                Name is <i>required</i>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="customer-form-field">
            <mat-label>Address</mat-label>
            <input matInput placeholder="Address" formControlName="address" required>
            <mat-error *ngIf="customerForm.controls?.address?.hasError('required')">
                Address is <i>required</i>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="customer-form-field">
            <mat-label>City</mat-label>
            <input matInput placeholder="City" formControlName="city" required>
            <mat-error *ngIf="customerForm.controls?.city?.hasError('required')">
                City is <i>required</i>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="customer-form-field">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" formControlName="email" required email>
            <mat-error *ngIf="customerForm.controls.email.hasError('email')">
                Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="customerForm.controls.email.hasError('required')">
                email is <i>required</i>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="country-form-field country-field">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" (selectionChange)="preapreTmz()">
                <mat-option *ngFor="let item of countries" [value]="item.id">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="tmz-form-field country-field">
            <mat-label>Tmz</mat-label>
            <mat-select formControlName="timeZone" >
                <mat-option *ngFor="let item of tmzs" [value]="item.name">
                    {{item.name}} 
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="customer-form-field">
            <ngx-mat-file-input formControlName="imageBin" accept="image"></ngx-mat-file-input>
            <mat-hint>Image/logo [max {{imgaMaxSize}} Mb]</mat-hint>
            <mat-error *ngIf="customerForm.controls.imageBin.hasError('maxSize')">
                size is more then <i>maxSize</i>
            </mat-error>
        </mat-form-field>
        <mat-checkbox *ngIf="customerForm.controls?.id" class="customer-form-field" formControlName="deleteImg" >Delete Img</mat-checkbox>

        <button mat-raised-button color="primary" type="reset" (click)="clear()" class="editActionButton">Clear</button>
        <button mat-raised-button color="primary" type="submit" class="editActionButton"
            [disabled]="!customerForm.valid">Save</button>

    </form>

    <!-- Useful during the dev

    <p>
        Form Status: {{ customerForm.status }}
        Form Value: {{ customerForm.value | json}}
    </p>
-->
</div>